import { render, staticRenderFns } from "./Impacts.vue?vue&type=template&id=81773f1a&"
import script from "./Impacts.vue?vue&type=script&lang=js&"
export * from "./Impacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports